import _ from 'lodash-es';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryRule from '~/scripts/services/model/query-rule';
import QueryWhere from '~/scripts/services/model/query-where';
import QueryWhereRules from '~/scripts/services/model/query-where-rules';
import QueryWhereNode from '~/scripts/services/model/query-where-node';
// eslint-disable-next-line import/no-cycle
import QueryWhereChild from '~/scripts/services/model/query-where-child';
// eslint-disable-next-line import/no-cycle
import { operators, operatorsByType, types } from '../query-editor/query-editor.controller';
// eslint-disable-next-line import/no-cycle
import QueryBuilderChildrenController from '../query-builder-children/query-builder-children.controller';
import QueryTab from '../query-tab';
import './query-builder.scss';

export default class QueryBuilderController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Notification,
		User) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Notification = Notification;
		this.User = User;

		/** @type {?QueryBuilderChildrenController} */
		this.children = null;

		this.conditions = [
			{ name: 'AND' },
			{ name: 'OR' },
		];

		/** @type {?string} */
		this.error = null;

		/** @type {?(QueryWhere|QueryWhereRules)} */
		this.group = null;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {any} */
		this.ngModelCtrl = null;

		this.operators = operators;
		this.options = undefined;

		/** @type {?QueryBuilderController} */
		this.parent = null;

		/** @type {?number} */
		this.parentIndex = null;

		/** @type {?(QueryWhereRule | QueryWhere)} */
		this.parentGroup = null;

		/** @type {any} */
		this.ruleOptions = {};

		/** @type {?(QueryWhereRule | QueryWhereRules | QueryRule | QueryWhere)[]} */
		this.rules = [];

		/** @type {?QueryTab} */
		this.tab = null;
	}

	$doCheck() {
		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validate();
		}
	}

	$onInit() {
		if (this.parentIndex === undefined) {
			this.parentIndex = null;
		}

		if (this.options === undefined) {
			this.options = {
				ruleValueSpecificItems: [],
			};
		}

		this.$scope.$watch('$ctrl.group', (/** @type {any} */ newValue, /** @type {any} */ oldValue) => {
			if (!_.isEqual(newValue, oldValue) && this.editor?.queryEditorForm) {
				this.editor.queryEditorForm.$setDirty();
			}
		}, true);

		if (this.group instanceof QueryWhere && this.group?.rules) {
			this.rules = this.group.rules;
		}
		else if (this.group instanceof QueryWhereRule && this.group?.rules) {
			this.rules = this.group.rules.items;
		}
		else if (this.group instanceof QueryWhereRules) {
			this.rules = this.group.items;
		}
		else {
			// @ts-ignore
			console.warn(`class unknown ${this.group?.constructor.name}`);
		}

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.required = () => !!this.checkGroup();
		}

		this.ruleOptions.nodrag = !!this.children;

		if (!this.group || Array.isArray(this.group)) {
			this.group = new QueryWhere();
		}
	}

	addGroup() {
		if (!Array.isArray(this.rules)) {
			this.rules = [];
		}

		if (this.group instanceof QueryWhereRules || this.group instanceof QueryWhereRule) {
			const node = this.children?.group?.node;
			const rules = [];
			if (node instanceof QueryWhereNode) {
				const rule = new QueryWhereRule(null, node);
				rule.operator = operatorsByType[types[node.type]][1].id;
				rules.push(rule);
			}
			const rulesGroup = new QueryWhereRules({
				items: rules,
			}, node instanceof QueryWhereNode ? node : null);
			this.rules.push(rulesGroup);
		}
		else {
			this.rules.push(new QueryWhere());
		}
	}

	checkGroup() {
		let returnValue = true;
		if (!Array.isArray(this.rules)) {
			this.rules = [];
		}
		if (this.rules && !!this.parentGroup && this.rules.length === 0) {
			returnValue = false;
			this.error = this.$translate.instant('query.errors.empty_group');
		}
		// 	else {
		// 		for (const rule of this.rules) {
		// 			if (rule instanceof QueryRule && rule.operator && rule.operator in this.operators && !rule.variable) {
		// 				if (this.operators[rule.operator].nb_inputs > 1 && Array.isArray(rule.value)) {
		// 					for (const value of rule.value) {
		// 						if (this.isEmpty(value) || !rule.field) {
		// 							returnValue = false;
		// 							this.error = this.$translate.instant('query.errors.string_empty');
		// 						}
		// 					}
		// 				}
		// 				else if (this.operators[rule.operator].nb_inputs === 1 && (this.isEmpty(rule.value))) {
		// 					returnValue = false;
		// 					this.error = this.$translate.instant('query.errors.string_empty');
		// 				}
		// 				if (rule.field === 'attribut' && !rule.attribut) {
		// 					returnValue = false;
		// 					this.error = this.$translate.instant('query.errors.attribute_empty');
		// 				}
		// 			}
		// 		}
		// 	}

		if (returnValue) {
			this.error = null;
		}

		return returnValue;
	}

	/**
	 * @param {number} index
	 * @param {any} r
	 * @returns {any} result
	 */
	// eslint-disable-next-line class-methods-use-this
	dropRule(index, r) {
		if (!(this.group instanceof QueryWhere)) {
			return false;
		}
		// Avoid to drop columns
		if (!('rules' in r) && (!(r.type in types) || (this.editor && 'op' in r))) {
			return false;
		}

		// Return false here to cancel drop. Return true if you insert the item yourself.
		let rule = new QueryRule();
		if (r.name && !r.field) {
			if (!('type' in r)) {
				r.type = 'K_NODE;STRING';
			}

			// from class
			rule.field = r.kid || r.node;
			rule.label = r.name;
			rule.operator = operatorsByType[types[r.type]][1].id;
			rule.type = r.type;
			rule.linker_kid = r.linker_kid;

			if ('linker_info' in r) {
				rule.label += ` :: ${r.linker_info.name}`;
				rule.linker_info = r.linker_info;
			}

			rule.path = r.path || [
				{
					kid:        r.node,
					name:       r.name,
					linker_kid: r.linker_kid || '0',
					type:       r.type,
				},
			];
			rule.path = r.path;
		}
		else {
			rule = new QueryRule(r);
		}

		if (this.children?.group?.node) {
			const { /** @type {QueryWhereNode} */ node } = this.children.group;
			let penultimateItem;
			if (r.path?.length > 1) {
				penultimateItem = r.path.slice(-2, -1)[0];
			}
			else if (node instanceof QueryWhereNode) {
				const children = node.getChildren();
				if (Array.isArray(children) && !children.some(c => c.kid === r.field && c.linker_kid === r.linker_kid)) {
					console.warn('this node isn\'t a child of parent node');
					return false;
				}
			}

			if (penultimateItem && node instanceof QueryWhereNode && (penultimateItem?.kid !== node?.kid
				|| penultimateItem?.linker_kid !== node.linker_kid)) {
				return false;
			}
		}

		return rule;
	}

	/**
	 * @param {string | null | any[]} value
	 * @returns {boolean} is rules empty?
	 */
	isEmpty(value) {
		let returnValue = false;

		if (Array.isArray(value)) {
			returnValue = value.length === 0;
			for (const v of value) {
				returnValue = this.isEmpty(v);
			}
		}
		else if (value === null || (typeof value === 'string' && value.trim() === '')) {
			returnValue = true;
		}

		return returnValue;
	}

	isQueryWhereInstance() {
		return this.group instanceof QueryWhere;
	}

	/**
	 * @param {number} index
	 */
	removeCondition(index) {
		this.rules?.splice(index, 1);
	}

	/**
	 * @param {?number} index
	 */
	removeGroup(index) {
		const parentGroup = this.parent?.group || this.parentGroup;
		if (parentGroup) {
			if (index === null && (parentGroup instanceof QueryWhere || parentGroup instanceof QueryWhereChild)) {
				parentGroup.removeRules();
			}
			else if (typeof index === 'number') {
				if (parentGroup instanceof QueryWhereRule && parentGroup.rules?.items) {
					parentGroup.rules.items.splice(index, 1);
					if (parentGroup.rules.items.length === 0) {
						parentGroup.rules = null;
					}
				}
				else if (parentGroup instanceof QueryWhereRules && parentGroup.items) {
					parentGroup.items.splice(index, 1);
					if (this.children?.group && parentGroup.items.length === 0) {
						this.children.group.rules = null;
					}
				}
				else if (parentGroup instanceof QueryWhere) {
					parentGroup.rules?.splice(index, 1);
				}
			}
		}
	}

	/**
	 * @param {number} index
	 */
	removeRule(index) {
		this.rules?.splice(index, 1);
	}
}
